/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteProjectBillToInput = {
    projectBillToId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeleteProjectBillToMutationVariables = {
    input: DeleteProjectBillToInput;
};
export type DeleteProjectBillToMutationResponse = {
    readonly deleteProjectBillTo: {
        readonly deletedProjectBillToId: string | null;
    } | null;
};
export type DeleteProjectBillToMutation = {
    readonly response: DeleteProjectBillToMutationResponse;
    readonly variables: DeleteProjectBillToMutationVariables;
};



/*
mutation DeleteProjectBillToMutation(
  $input: DeleteProjectBillToInput!
) {
  deleteProjectBillTo(input: $input) {
    deletedProjectBillToId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteProjectBillToInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectBillToPayload",
    "kind": "LinkedField",
    "name": "deleteProjectBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProjectBillToId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProjectBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProjectBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteProjectBillToMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProjectBillToMutation(\n  $input: DeleteProjectBillToInput!\n) {\n  deleteProjectBillTo(input: $input) {\n    deletedProjectBillToId\n  }\n}\n"
  }
};
})();
(node as any).hash = '984a2380730e2a11191cd2c63ae0fb25';
export default node;
